import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import relationships from 'Consts/Relationships';
import MetaPickList from 'Components/AdvisorApp/Viewport/NotificationCenter/MetaPickList';

const styles = theme => ({
  root: {
    paddingRight: theme.spacing(1),
  },
});

const AccountPicklist = ({ classes, onSelect }) => {
  const { householdResource } = useSimpleHousehold();
  const [options, setOptions] = React.useState();
  const [latestSelection, setLatestSelection] = React.useState([]);

  const handleTypeSelect = (selection) => {
    setLatestSelection(selection);
    onSelect(selection);
  };

  const createOptions = (newAccountCollection) => {
    const newOptions = newAccountCollection.resources().list().map((account) => {
      return { id: account.id(), prompt: `${account.attr('name')} - ${account.selectedOptions('type', 'prompt')}` };
    });
    return [{ id: '-1', prompt: 'Select Account...' }, ...newOptions];
  };

  React.useEffect(() => {
    if (!householdResource) {
      return;
    }

    const link = householdResource.relationship(relationships.accounts).link('related');
    if (link) {
      link.Get().then((newAccountCollection) => {
        const newOptions = createOptions(newAccountCollection);
        setOptions(newOptions);
        setLatestSelection([newOptions[0].id]);
      });
    }
  }, [householdResource]);

  if (!options || options.length === 0) {
    return (
      <div />
    );
  }
  return (
    <MetaPickList
      className={classes.root}
      handleSelect={handleTypeSelect}
      options={options}
      value={latestSelection}
      allowMultiple={false}
      disableUnderline
    />
  );
};

AccountPicklist.propTypes = {
  classes: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default withStyles(styles)(AccountPicklist);
